import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=44b00af8&scoped=true"
import script from "./ThankYou.vue?vue&type=script&lang=ts"
export * from "./ThankYou.vue?vue&type=script&lang=ts"
import style0 from "./ThankYou.vue?vue&type=style&index=0&id=44b00af8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b00af8",
  null
  
)

export default component.exports